import React, { ChangeEvent, useState } from "react";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";

const CustomTextField: React.FC<TextFieldProps> = (props) => {
  const [shrink, setShrink] = useState(typeof props.value !== "undefined" && String(props.value).length > 0);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    props.onChange && props.onChange(e);
    setShrink(e.target.value.length > 0);
  };

  return (
    <TextField
      {...props}
      InputLabelProps={{
        ...props.InputLabelProps,
        shrink: shrink || (props.InputLabelProps && props.InputLabelProps.shrink),
      }}
      onChange={onChange}
      onKeyUp={onChange as any}
    />
  );
};

export default CustomTextField;
